<div class="columns is-vcentered">
  <div class="column">
    <portal-search-box
      [entities]="searchEntities"
      [searchTerm]="searchTerm"
      [selectedSelector]="selectedSearchSelector"
      [defaultEntityId]="entityNameSelector"
      (entitySearched)="onOrganisationSearched($event)"
      (searchEntityRemoved)="onSearchEntityRemoved($event)"
      (searchBoxInitComplete)="searchBoxInitComplete()"
      (searchUpdated)="onSearchUpdated($event)"
    ></portal-search-box>

    <div class="field is-grouped filter-container">
      <div class="control" *ngIf="filterTouched">
        <button
          i18n
          class="button is-outlined"
          (click)="resetFilter()"
          type="button"
          data-e2e="usersFilter-button-clear-filter"
          title="Clear filter"
          i18n-title
        >
          Clear filters
        </button>
      </div>
    </div>
  </div>
</div>
